import { isNull } from '@app/utils'

import { sortOrder, TABLE_COLUMN_SORT_BASE_CLASS_NAME } from './constants'

import type { SortOrder } from 'antd/es/table/interface'
import type { SortingScheme, SortingParametersMap } from './types'

export const getInitialSortingParameters =
  <ColumnType>(sortingScheme: SortingScheme<ColumnType>) =>
    (): SortingParametersMap<ColumnType> => {
      return Object.entries(sortingScheme).reduce<SortingParametersMap<ColumnType>>((map, [key, value]) => {
        const columnKey = key as keyof ColumnType
        const sortingParameter = value as string

        map.set(columnKey, { sortingParameter, order: null, columnClassName: TABLE_COLUMN_SORT_BASE_CLASS_NAME })

        return map
      }, new Map())
    }

export const getOrder = (order: SortOrder): SortOrder => {
  if (isNull(order)) return sortOrder.ASCEND

  if (order === sortOrder.ASCEND) return sortOrder.DESCEND

  return null
}

export const getColumnClassName = (order: SortOrder): string => {
  return isNull(order)
    ? TABLE_COLUMN_SORT_BASE_CLASS_NAME
    : `${TABLE_COLUMN_SORT_BASE_CLASS_NAME} ${TABLE_COLUMN_SORT_BASE_CLASS_NAME}_${order}`
}

export const getSortingParameters = <ColumnType>(sortingParametersMap: SortingParametersMap<ColumnType>): string[] => {
  return [...sortingParametersMap]
    .filter(([, { order }]) => !isNull(order))
    .map(([, { order, sortingParameter }]) => (order === sortOrder.DESCEND ? '-' : '') + sortingParameter)
}
